import Btn from "@/components/Btn";
import CustomLabel from "@/components/CustomLabel";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Input } from "@progress/kendo-react-inputs";
import React, { useEffect, useState } from "react";

interface IProps {
  isOpen: boolean;
  mode: "saveAs" | "rename";
  currentName?: string;
  onClose: () => void;
  onSave: (name: string) => void;
}

function NameDialog({ isOpen, mode, currentName = "", onClose, onSave }: IProps) {
  const [name, setName] = useState<string>(currentName);

  useEffect(() => {
    setName(currentName);
  }, [currentName, isOpen]);

  const handleSave = () => {
    if (name.trim()) {
      onSave(name.trim());
      setName("");
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && name.trim()) {
      handleSave();
    }
  };

  if (!isOpen) return null;

  return (
    <>
    <style>{`
        .k-input:not(.k-datepicker) {
            border-radius: 3px !important;
            padding: 5px 7px;
        }
      `}</style>
    <Dialog 
      width={450} 
      title={mode === "saveAs" ? "Save View As" : "Rename View"} 
      onClose={onClose} 
      className="custom-dialog"
    >
      <div className="mb-4">
        <CustomLabel label={"View Name"} required={true} />
        <Input
          type="text"
          placeholder={"Enter view name"}
          value={name}
          onChange={(e: any) => {
            setName(e.target.value);
          }}
          onKeyPress={handleKeyPress}
          autoFocus
        />
      </div>
      <DialogActionsBar>
        <div className="flex justify-end gap-3 h-[38px]">
          <div className="w-[86px] h-[18px]">
            <Btn variant="tertiary" text={"Cancel"} border disabled={false} onClick={onClose} />
          </div>
          <div className="w-[86px] h-[18px]">
            <Btn variant="primary" disabled={!name.trim()} text={mode === "saveAs" ? "Save" : "Rename"} onClick={handleSave} />
          </div>
        </div>
      </DialogActionsBar>
    </Dialog>
    </>
  );
}

export default NameDialog;
